import { WtpCountry } from './wtp-country';
import { WorldRegion } from './world-region';

export class CountryWithRegion {
  country: WtpCountry;
  worldRegion: WorldRegion [];
}
